//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useEffect, useState } from 'react';

// === STYLES ===
import { TableRow, TableCell, IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import PersonAddDisabledIcon from '@mui/icons-material/PersonAddDisabled';

// === COMPONENTS ===
import { UserRoles } from './UserRoles';
import { EditUserDialog } from '../EditUserDialog';

import { requestPasswordReset } from 'api/prokey/prokey.axios';

//#endregion

//-----------------------------------------------------------------
export function UserRow({ user, roles, refreshUsers, modifyUser }) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const [ assigned_roles     , setAssignedRoles      ] = useState( [] );
  const [ available_roles    , setAvailableRoles     ] = useState( [] );
  const [ showEditUsersModal , setShowEditUsersModal ] = useState( false );

  //#endregion

  //#region [STYLES]

  const _styles = {
    container: {

    }
  }


  //#endregion

  //#region [EFFECT]

  useEffect(() => {
    const user_roles      = user.roles;//.map((role) => role.RoleName);
    const assigned_roles  = roles.filter( (x) =>  user_roles.includes(x.RoleName) );
    const available_roles = roles.filter( (x) => !user_roles.includes(x.RoleName) );
    setAssignedRoles ( assigned_roles  );
    setAvailableRoles( available_roles );
  }, [user, roles]);

  //#endregion

  //#region [DISPLAY]

  function display() {
    const enableAction = user.disabledAt ? 'enable' : 'disable';
    const enableIcon = user.disabledAt ? (
      <GroupAddIcon />
    ) : (
      <PersonAddDisabledIcon />
    );

    return (
      <TableRow sx={{ width: '100%' }} key={user.Id}>
        <TableCell sx={{border: 'none' }}>
          <EditUserDialog
            showDialog={showEditUsersModal}
            setShowDialog={setShowEditUsersModal}
            // refreshUsers={refreshUsers}
            user={user}
          />
          <Tooltip title='Edit User'>
            <IconButton
              aria-label='edit-user'
              aria-controls='edit-user'
              color='primary'
              onClick={() => setShowEditUsersModal(true)}
            >
              <EditIcon fontSize='small' />
            </IconButton>
          </Tooltip>
          <Tooltip title='Reset User Password'>
            <IconButton
              aria-label='reset-user-pass'
              aria-controls='reset-user-pass'
              color='primary'
              onClick={ () =>requestPasswordReset( user.Id ) } //modifyUser('reset', user.Id)}
            >
              <VpnKeyIcon fontSize='small' />
            </IconButton>
          </Tooltip>
          <Tooltip title='Enable/Disable User'>
            <IconButton
              aria-label='enable-disable-user'
              aria-controls='enable-disable-user'
              color='primary'
              onClick={() => modifyUser(enableAction, user.Id)}
            >
              {enableIcon}
            </IconButton>
          </Tooltip>
        </TableCell>
        <TableCell sx={{border: 'none' }} >{ user.Username       }</TableCell>
        <TableCell sx={{border: 'none' }} >{ user.FirstName      }</TableCell>
        <TableCell sx={{border: 'none' }} >{ user.LastName       }</TableCell>
        <TableCell sx={{border: 'none' }} >{ user.Email          }</TableCell>
        <TableCell sx={{border: 'none' }} >{ user.Company        }</TableCell>
        <TableCell sx={{border: 'none' }} >{ user.PasswordExpire }</TableCell>
        <UserRoles
          userRoles={assigned_roles}
          availableRoles={available_roles}
          userId={user.Id}
          // refreshUsers={refreshUsers}
        />
      </TableRow>
    );
  }

  //#endregion

  return display();
}
